// Animation timing constants
export const SPARKLE_FADE_IN_DURATION = 150;
export const ROTATION_STOP_DURATION = 200;
export const CROSSFADE_DURATION = 300;
export const SPARKLE_MOVE_DURATION = 300;

// Animation phase constants
export const PHASES = {
  ENTERING: 'entering',
  ACTIVE: 'active',
  STOPPING: 'stopping',
  MORPHING: 'morphing',
  COMPLETE: 'complete',
};
